"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2826],{

/***/ 354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MM": function() { return /* binding */ listingRearranger; },
/* harmony export */   "eS": function() { return /* binding */ contentRearranger; }
/* harmony export */ });
function contentRearranger(param) {
    var content = param.content, _adsOptions = param.adsOptions, adsOptions = _adsOptions === void 0 ? {
        enableMobile: true,
        enableDesktop: true,
        positionMobile: 4,
        positionDesktop: 4
    } : _adsOptions, _shouldUseIdCountPosition = param.shouldUseIdCountPosition, shouldUseIdCountPosition = _shouldUseIdCountPosition === void 0 ? true : _shouldUseIdCountPosition;
    var length = content === null || content === void 0 ? void 0 : content.length;
    var maxIdCountPosition = 10;
    if (length < adsOptions.positionMobile && length < adsOptions.positionDesktop) return content;
    var isValidDesktop = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return i % adsOptions.positionDesktop === 0 && i >= adsOptions.positionDesktop && i < length && adsOptions.enableDesktop;
    };
    var isValidMobile = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return i % adsOptions.positionMobile === 0 && i >= adsOptions.positionMobile && i < length && adsOptions.enableMobile;
    };
    var contentRearranged = [];
    var adMobileCount = 1;
    var adDesktopCount = 1;
    content.forEach(function(block, i) {
        var adMobile = {
            tipo: "adMobile",
            idCountPosition: shouldUseIdCountPosition && adMobileCount <= maxIdCountPosition ? adMobileCount.toString() : ""
        };
        var adDesktop = {
            tipo: "adDesktop",
            idCountPosition: shouldUseIdCountPosition && adDesktopCount <= maxIdCountPosition ? adDesktopCount.toString() : ""
        };
        if (content.length >= 4 && i === 4) {
            contentRearranged.push({
                tipo: "cardCTA"
            });
        }
        if (i === 1) {
            contentRearranged.push(adMobile);
            adMobileCount += 1;
            contentRearranged.push(adDesktop);
            adDesktopCount += 1;
        }
        if (isValidMobile(i)) {
            if (adMobileCount <= maxIdCountPosition) contentRearranged.push(adMobile);
            if (adMobileCount <= maxIdCountPosition) adMobileCount += 1;
        }
        if (isValidDesktop(i)) {
            if (adDesktopCount <= maxIdCountPosition) contentRearranged.push(adDesktop);
            if (adDesktopCount <= maxIdCountPosition) adDesktopCount += 1;
        }
        contentRearranged.push(block);
        if (content.length > 9 && i === 8) {
            contentRearranged.push({
                tipo: "readMore"
            });
        }
    });
    return contentRearranged;
}
var adsContainsMobile = {
    ads: true,
    mobile: true
};
var adsContainsDesktop = {
    ads: true,
    mobile: false
};
function listingRearranger(param) {
    var content = param.content, primary = param.primary, _hasNoAds = param.hasNoAds, hasNoAds = _hasNoAds === void 0 ? false : _hasNoAds, _sizeMobile = param.sizeMobile, sizeMobile = _sizeMobile === void 0 ? 3 : _sizeMobile, _sizeDesktop = param.sizeDesktop, sizeDesktop = _sizeDesktop === void 0 ? 6 : _sizeDesktop;
    var length = content === null || content === void 0 ? void 0 : content.length;
    var result = [];
    if (!primary) {
        result.push(adsContainsDesktop);
    }
    var chunkified = [];
    content.forEach(function(element, index) {
        chunkified.push(element);
        if ((index + 1) % sizeMobile === 0 && index + 1 >= sizeMobile && !hasNoAds) chunkified.push(adsContainsMobile);
        if ((index + 1) % sizeDesktop === 0 && index + 1 >= sizeDesktop) {
            result.push({
                chunck: chunkified
            });
            if (index + 1 < length && !hasNoAds) result.push(adsContainsDesktop);
            chunkified = [];
        }
        if (chunkified.length > 0 && length === index + 1) {
            result.push({
                chunck: chunkified
            });
        }
    });
    return result;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    contentRearranger: contentRearranger,
    listingRearranger: listingRearranger
});


/***/ }),

/***/ 2826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FeaturedLastNews; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Layout/WrapperContentLastNews/index.tsx


function WrapperContentLastNews(param) {
    var children = param.children, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "bg-mglGray50" : _backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,className/* default */.Z)("flex w-full flex-col flex-wrap content-center justify-center p-0 py-[40px]", backgroundColor && backgroundColor, variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()]),
        children: children
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/services/api.ts
var api = __webpack_require__(8469);
// EXTERNAL MODULE: ./src/lib/gtm.ts
var gtm = __webpack_require__(9084);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Ads/Rearrangers/index.ts
var Rearrangers = __webpack_require__(354);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./src/components/Ads/Google/AdsTypeGeneratorsMemo/index.tsx
var AdsTypeGeneratorsMemo = __webpack_require__(9831);
// EXTERNAL MODULE: ./src/components/Layout/NewsTimeLine/index.tsx
var NewsTimeLine = __webpack_require__(2835);
;// CONCATENATED MODULE: ./src/components/Layout/PageSpotter/index.tsx


function PageSpotter(param) {
    var children = param.children, page = param.page;
    var pageNumber = (0,react.useRef)(page);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pg-article",
        "data-page": pageNumber.current,
        children: children
    });
}

// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./src/components/Layout/ItemListLastNews/styles.tsx
var styles = __webpack_require__(2747);
// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
;// CONCATENATED MODULE: ./src/components/Layout/ItemListLastNews/index.tsx
/* eslint-disable no-prototype-builtins */ /* eslint-disable react/no-array-index-key */ /* eslint-disable jsx-a11y/anchor-is-valid */ 









var PropMetaInfo = {
    age: true,
    category: true
};
var PropAutor = {
    image: true,
    imgInImage: true,
    text: false
};
function ItemListNews(param) {
    var items = param.items, page = param.page, backgroundColor = param.backgroundColor;
    var pagePrimary = items.length === 3;
    var PropTitle = {
        altColorInHover: true,
        colorHover: designSystemColors/* mglBlue.mglBlue400 */.Db.mglBlue400
    };
    var pagination = page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperContent/* default */.Z, {
            isOnHeader: true,
            backgroundColor: backgroundColor,
            children: items.map(function(item, index) {
                return "chunck" in item ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSpotter, {
                    page: pagination,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ContentListNews */.hn, {
                        children: item.chunck.map(function(timeline, nestedIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: !("ads" in timeline) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTimeLine/* default */.Z, {
                                    news: timeline,
                                    title: true,
                                    propsTitle: PropTitle,
                                    effectImage: true,
                                    metaInfo: true,
                                    propsMetaInfo: PropMetaInfo,
                                    autor: true,
                                    propsAutor: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, PropAutor), {
                                        imgRounded: timeline.autor !== "Lu do Magalu"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                                    type: "rectangle/main/listing"
                                }, nestedIndex)
                            }, nestedIndex);
                        })
                    })
                }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BillboardContainer */.bL, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                        type: "billboard/main/listing"
                    })
                }, index);
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/services/fbConvetionAPI.ts
var fbConvetionAPI = __webpack_require__(6982);
;// CONCATENATED MODULE: ./src/components/Layout/LastNews/mimir.tsx
/* eslint-disable no-console */ // @refresh reset













var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var mimirBase = (publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR || "").replace(/\/$/, "");
// Mimir retorna status 3 quando o token de paginação é inválido ou corrompido.
// Isso pode ocorrer após deploy (tokens antigos expiram) ou ao misturar ambientes.
// Tratamento: descartar o token e reiniciar da primeira página.
var MIMIR_STATUS_INVALID_PAGINATION = 3;
var LoadingLogo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8054).then(__webpack_require__.bind(__webpack_require__, 8054));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8054)
            ];
        }
    }
});
var InfiniteScrollComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6260).then(__webpack_require__.bind(__webpack_require__, 6260));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6260)
            ];
        }
    }
});
var routeTypes = (/* unused pure expression or super */ null && ([
    "mais",
    "categoria",
    "editoria",
    "tipo",
    "tipoDePublicacao",
    "produto",
    "empresa",
    "autor",
    "celebridade",
    "ultimas",
    "id"
]));
function PageNewsWithMimir(param) {
    var _posts = param.posts, posts = _posts === void 0 ? [] : _posts, paginacao = param.paginacao, rootPage = param.rootPage, initialPage = param.initialPage, routeType = param.routeType, route = param.route, _noPagination = param.noPagination, noPagination = _noPagination === void 0 ? false : _noPagination, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "mglGray50" : _backgroundColor, setNoItemsFound = param.setNoItemsFound;
    var ref;
    var endpoints = function(route) {
        return {
            ultimas: "".concat(mimirBase, "/timelines/ultimas/"),
            mais: "".concat(mimirBase, "/timelines/mais/").concat(route, "/").concat(route === "lidas" ? "1-dia" : "7-dias"),
            categoria: "".concat(mimirBase, "/timelines/ultimas/categoria/").concat(route),
            editoria: "".concat(mimirBase, "/timelines/ultimas/editoria/").concat(route),
            tipo: "".concat(mimirBase, "/timelines/ultimas/tipo/").concat(route),
            tipoDePublicacao: "".concat(mimirBase, "/timelines/ultimas/tipo/artigo/").concat(route),
            empresa: "".concat(mimirBase, "/timelines/ultimas/empresa/").concat(route),
            produto: "".concat(mimirBase, "/timelines/ultimas/").concat(route),
            autor: "".concat(mimirBase, "/timelines/ultimas/autor/").concat(route),
            celebridade: "".concat(mimirBase, "/timelines/ultimas/celebridade/").concat(route),
            id: "".concat(mimirBase, "/timelines/ultimas/id/").concat(route)
        };
    };
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var pageNewsSpan = currentSpan && currentSpan.startChild({
        op: "pageNews"
    });
    var iniPage = initialPage ? parseInt(initialPage.toString().replace("p", ""), 10) : 0;
    var ref1 = (0,react.useState)(iniPage || 0), atualPage = ref1[0], setAtualPage = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(false), isLastPage = ref3[0], setIsLastPage = ref3[1];
    var ref4 = (0,react.useState)((0,Rearrangers/* listingRearranger */.MM)({
        content: posts,
        primary: true
    })), dataPosts = ref4[0], setDataPosts = ref4[1];
    var pageRef = (0,react.useRef)(iniPage && iniPage > 1 ? iniPage : 1);
    var paginationCodeRef = (0,react.useRef)(paginacao);
    var routeRef = (0,react.useRef)(route);
    var routeTypeRef = (0,react.useRef)(routeType);
    // Resetar estado ao mudar de categoria
    (0,react.useEffect)(function() {
        paginationCodeRef.current = paginacao;
        pageRef.current = iniPage && iniPage > 1 ? iniPage : 1;
        routeRef.current = route;
        routeTypeRef.current = routeType;
        setDataPosts([]);
    }, [
        route,
        routeType
    ]);
    (0,react.useEffect)(function() {
        if (posts.length > 0) {
            var dataItensNew = (0,Rearrangers/* listingRearranger */.MM)({
                content: posts,
                primary: true
            });
            setDataPosts(dataItensNew);
        }
    }, [
        posts
    ]);
    var shouldStopPagination = !paginationCodeRef && dataPosts.length > 0;
    var getMorePosts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var isFirstPage, atualRoute, atualRouteType, endpointsAtual, endpointUrl, data, dataItensNew, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        isFirstPage = !paginationCodeRef.current;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            routeRef.current
                        ];
                    case 2:
                        atualRoute = _state.sent();
                        return [
                            4,
                            routeTypeRef.current
                        ];
                    case 3:
                        atualRouteType = _state.sent();
                        return [
                            4,
                            endpoints(atualRoute)
                        ];
                    case 4:
                        endpointsAtual = _state.sent();
                        endpointUrl = new URL(endpointsAtual[atualRouteType]);
                        if (paginationCodeRef.current) {
                            endpointUrl.searchParams.delete("p");
                            endpointUrl.searchParams.append("pagination", paginationCodeRef.current);
                        }
                        return [
                            4,
                            api/* mimir.get */.Ny.get(endpointUrl.toString())
                        ];
                    case 5:
                        data = _state.sent().data;
                        if (data.status === MIMIR_STATUS_INVALID_PAGINATION) {
                            paginationCodeRef.current = undefined;
                            setIsLoading(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,Rearrangers/* listingRearranger */.MM)({
                                content: data.data.timeline.itens,
                                primary: isFirstPage
                            })
                        ];
                    case 6:
                        dataItensNew = _state.sent();
                        paginationCodeRef.current = data.data.timeline.paginacao && data.data.timeline.paginacao;
                        if (dataPosts.length > 0) pageRef.current = pageRef.current + 1;
                        setDataPosts(function(oldVal) {
                            return (0,_to_consumable_array/* default */.Z)(oldVal).concat((0,_to_consumable_array/* default */.Z)(dataItensNew));
                        });
                        setNoItemsFound(isFirstPage && data.data.timeline.itens.length === 0);
                        setIsLastPage(!data.data.timeline.paginacao);
                        setIsLoading(false);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        console.log(error);
                        setIsLoading(false);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function getMorePosts() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var ref, ref1, ref2, ref3, ref4;
            var pagesArticles = Array.from(document.getElementsByClassName("pg-article"));
            var pg = parseInt((ref = pagesArticles[0]) === null || ref === void 0 ? void 0 : ref.getAttribute("data-page"), 10);
            if (((ref2 = (ref1 = pagesArticles[0]) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.y) > 0 && atualPage > 0) {
                setAtualPage(0);
                var rtPage = rootPage === "/" ? "/" : "".concat("/".concat(rootPage, "/")).concat(iniPage > 1 ? "p/".concat(iniPage, "/") : "");
                if (!noPagination) window.history.pushState("", "", rtPage);
                (0,gtm/* PageViewGTM */.sb)(window.location.pathname);
                (0,fbConvetionAPI/* sendPageViewEventToFacebookAPI */.b)({
                    eventSourceUrl: window.location.href,
                    eventId: crypto.randomUUID()
                });
                return;
            }
            if (((ref4 = (ref3 = pagesArticles[0]) === null || ref3 === void 0 ? void 0 : ref3.getBoundingClientRect()) === null || ref4 === void 0 ? void 0 : ref4.y) > 0) {
                return;
            }
            pagesArticles === null || pagesArticles === void 0 ? void 0 : pagesArticles.forEach(function(p, i) {
                var next = i + 1 <= pagesArticles.length ? pagesArticles[i + 1] : undefined;
                var pNext = next ? next === null || next === void 0 ? void 0 : next.getBoundingClientRect() : undefined;
                var pAtual = p === null || p === void 0 ? void 0 : p.getBoundingClientRect();
                pg = parseInt(p === null || p === void 0 ? void 0 : p.getAttribute("data-page"), 10);
                if (pAtual.y < 0 && pNext === undefined || pAtual.y < 0 && pNext.y > 0) {
                    if (pg !== atualPage) {
                        var routeValue;
                        if (rootPage === "/") {
                            routeValue = pg === 1 ? "/ultimas/" : "/ultimas/p/".concat(pg, "/");
                        } else if (rootPage === "podcast") {
                            routeValue = pg === 1 ? "/podcast/ultimos/" : "/podcast/ultimos/p/".concat(pg, "/");
                        } else {
                            routeValue = pg === 1 ? "/".concat(rootPage, "/") : "/".concat(rootPage, "/p/").concat(pg, "/");
                        }
                        (0,gtm/* PageViewGTM */.sb)(window.location.pathname);
                        (0,fbConvetionAPI/* sendPageViewEventToFacebookAPI */.b)({
                            eventSourceUrl: window.location.href,
                            eventId: crypto.randomUUID()
                        });
                        setAtualPage(pg);
                        if (!noPagination) window.history.pushState("", "", routeValue);
                    }
                }
            });
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "NewsContainer",
                children: [
                    dataPosts && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListNews, {
                        items: dataPosts,
                        page: pageRef.current,
                        backgroundColor: backgroundColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingLogo, {
                        isLoading: isLoading && !isLastPage
                    }),
                    dataPosts && !isLoading && !isLastPage && !shouldStopPagination && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScrollComponent, {
                        fetchMore: getMorePosts
                    })
                ]
            }),
            pageNewsSpan && pageNewsSpan.finish()
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/LastNewsWithButtom/mimir.tsx
/* eslint-disable no-console */ // @refresh reset













var mimir_publicRuntimeConfig = config_default()().publicRuntimeConfig;
var mimir_LoadingLogo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8054).then(__webpack_require__.bind(__webpack_require__, 8054));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8054)
            ];
        }
    }
});
var mimir_routeTypes = (/* unused pure expression or super */ null && ([
    "mais",
    "categoria",
    "editoria",
    "tipo",
    "tipoDePublicacao",
    "produto",
    "empresa",
    "autor",
    "celebridade",
    "ultimas",
    "id"
]));
function PageNewsWithMimirAndButtom(param) {
    var _posts = param.posts, posts = _posts === void 0 ? [] : _posts, paginacao = param.paginacao, rootPage = param.rootPage, initialPage = param.initialPage, routeType = param.routeType, route = param.route, _noPagination = param.noPagination, noPagination = _noPagination === void 0 ? false : _noPagination, _noScroll = param.noScroll, noScroll = _noScroll === void 0 ? false : _noScroll, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "mglGray50" : _backgroundColor, _itemsPerPage = param.itemsPerPage, itemsPerPage = _itemsPerPage === void 0 ? 6 : _itemsPerPage, _hideAds = param.hideAds, hideAds = _hideAds === void 0 ? false : _hideAds, setNoItemsFound = param.setNoItemsFound;
    var ref;
    var endpoints = function(route) {
        return {
            ultimas: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/"),
            mais: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/mais/").concat(route, "/").concat(route === "lidas" ? "1-dia" : "7-dias"),
            categoria: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/categoria/").concat(route),
            editoria: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/editoria/").concat(route),
            tipo: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/tipo/").concat(route),
            tipoDePublicacao: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/tipo/artigo/").concat(route),
            empresa: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/empresa/").concat(route),
            produto: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/").concat(route),
            autor: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/autor/").concat(route),
            celebridade: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/celebridade/").concat(route),
            id: "".concat(mimir_publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR, "/timelines/ultimas/id/").concat(route)
        };
    };
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var pageNewsSpan = currentSpan && currentSpan.startChild({
        op: "pageNews"
    });
    var iniPage = initialPage ? parseInt(initialPage.toString().replace("p", ""), 10) : 0;
    var stepSize = Math.max(itemsPerPage, 1);
    var normalizedInitialPosts = Array.isArray(posts) ? posts : [];
    var initialVisibleCount = normalizedInitialPosts.length > 0 ? Math.min(stepSize, normalizedInitialPosts.length) : 0;
    var ref1 = (0,react.useState)(iniPage || 0), atualPage = ref1[0], setAtualPage = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(!paginacao), isLastPage = ref3[0], setIsLastPage = ref3[1];
    var ref4 = (0,react.useState)(normalizedInitialPosts), allPosts = ref4[0], setAllPosts = ref4[1];
    var ref5 = (0,react.useState)(initialVisibleCount), visibleCount = ref5[0], setVisibleCount = ref5[1];
    var ref6 = (0,react.useState)((0,Rearrangers/* listingRearranger */.MM)({
        content: normalizedInitialPosts.slice(0, initialVisibleCount),
        primary: true,
        hasNoAds: hideAds,
        sizeDesktop: stepSize
    })), dataPosts = ref6[0], setDataPosts = ref6[1];
    var pageRef = (0,react.useRef)(iniPage && iniPage > 1 ? iniPage : 1);
    var paginationCodeRef = (0,react.useRef)(paginacao);
    var routeRef = (0,react.useRef)(route);
    var routeTypeRef = (0,react.useRef)(routeType);
    (0,react.useEffect)(function() {
        paginationCodeRef.current = paginacao;
        pageRef.current = iniPage && iniPage > 1 ? iniPage : 1;
        routeRef.current = route;
        routeTypeRef.current = routeType;
        var postsNormalized = Array.isArray(posts) ? posts : [];
        var nextVisible = postsNormalized.length > 0 ? Math.min(stepSize, postsNormalized.length) : 0;
        setAllPosts(postsNormalized.slice());
        setVisibleCount(nextVisible);
        setIsLastPage(!paginacao);
        setIsLoading(false);
        setNoItemsFound(postsNormalized.length === 0);
    }, [
        route,
        routeType,
        paginacao,
        iniPage,
        posts,
        stepSize,
        setNoItemsFound
    ]);
    (0,react.useEffect)(function() {
        var totalPosts = allPosts.length;
        if (totalPosts === 0 && visibleCount !== 0) {
            setVisibleCount(0);
            return;
        }
        if (totalPosts > 0 && visibleCount === 0) {
            setVisibleCount(Math.min(stepSize, totalPosts));
            return;
        }
        if (visibleCount > totalPosts) {
            setVisibleCount(totalPosts);
        }
    }, [
        allPosts,
        visibleCount,
        stepSize
    ]);
    (0,react.useEffect)(function() {
        var visiblePosts = allPosts.slice(0, visibleCount > 0 ? visibleCount : allPosts.length);
        var rearranged = (0,Rearrangers/* listingRearranger */.MM)({
            content: visiblePosts,
            primary: true,
            hasNoAds: hideAds,
            sizeDesktop: stepSize
        });
        setDataPosts(rearranged);
    }, [
        allPosts,
        visibleCount,
        hideAds,
        stepSize
    ]);
    var getMorePosts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var isFirstPage, atualRoute, atualRouteType, endpointsAtual, endpointUrl, data, _itens, newItems, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        isFirstPage = !paginationCodeRef.current;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        atualRoute = routeRef.current;
                        atualRouteType = routeTypeRef.current;
                        endpointsAtual = endpoints(atualRoute);
                        endpointUrl = new URL(endpointsAtual[atualRouteType]);
                        if (paginationCodeRef.current) {
                            endpointUrl.searchParams.delete("p");
                            endpointUrl.searchParams.append("pagination", paginationCodeRef.current);
                        }
                        return [
                            4,
                            api/* mimir.get */.Ny.get(endpointUrl.toString())
                        ];
                    case 2:
                        data = _state.sent().data;
                        newItems = (_itens = data.data.timeline.itens) !== null && _itens !== void 0 ? _itens : [];
                        paginationCodeRef.current = data.data.timeline.paginacao || undefined;
                        setAllPosts(function(oldVal) {
                            return (0,_to_consumable_array/* default */.Z)(oldVal).concat((0,_to_consumable_array/* default */.Z)(newItems));
                        });
                        if (newItems.length > 0) {
                            pageRef.current = pageRef.current + 1;
                        }
                        setNoItemsFound(isFirstPage && newItems.length === 0);
                        setIsLastPage(!data.data.timeline.paginacao);
                        return [
                            2,
                            newItems.length
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            2,
                            0
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getMorePosts() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLoadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var totalPosts, loaded;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isLoading) return [
                            2
                        ];
                        totalPosts = allPosts.length;
                        if (visibleCount < totalPosts) {
                            setVisibleCount(function(prev) {
                                return Math.min(prev + stepSize, totalPosts);
                            });
                            return [
                                2
                            ];
                        }
                        if (isLastPage) return [
                            2
                        ];
                        return [
                            4,
                            getMorePosts()
                        ];
                    case 1:
                        loaded = _state.sent();
                        if (loaded > 0) {
                            setVisibleCount(function(prev) {
                                return prev + stepSize;
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLoadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var ref, ref1, ref2, ref3, ref4;
            var pagesArticles = Array.from(document.getElementsByClassName("pg-article"));
            var pg = parseInt((ref = pagesArticles[0]) === null || ref === void 0 ? void 0 : ref.getAttribute("data-page"), 10);
            if (((ref2 = (ref1 = pagesArticles[0]) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.y) > 0 && atualPage > 0) {
                setAtualPage(0);
                var rtPage = rootPage === "/" ? "/" : "".concat("/".concat(rootPage, "/")).concat(iniPage > 1 ? "p/".concat(iniPage, "/") : "");
                if (!noPagination) window.history.pushState("", "", rtPage);
                (0,gtm/* PageViewGTM */.sb)(window.location.pathname);
                (0,fbConvetionAPI/* sendPageViewEventToFacebookAPI */.b)({
                    eventSourceUrl: window.location.href,
                    eventId: crypto.randomUUID()
                });
                return;
            }
            if (((ref4 = (ref3 = pagesArticles[0]) === null || ref3 === void 0 ? void 0 : ref3.getBoundingClientRect()) === null || ref4 === void 0 ? void 0 : ref4.y) > 0) {
                return;
            }
            pagesArticles === null || pagesArticles === void 0 ? void 0 : pagesArticles.forEach(function(p, i) {
                var next = i + 1 <= pagesArticles.length ? pagesArticles[i + 1] : undefined;
                var pNext = next ? next === null || next === void 0 ? void 0 : next.getBoundingClientRect() : undefined;
                var pAtual = p === null || p === void 0 ? void 0 : p.getBoundingClientRect();
                pg = parseInt(p === null || p === void 0 ? void 0 : p.getAttribute("data-page"), 10);
                if (pAtual.y < 0 && pNext === undefined || pAtual.y < 0 && pNext.y > 0) {
                    if (pg !== atualPage) {
                        var routeValue;
                        if (rootPage === "/") {
                            routeValue = pg === 1 ? "/ultimas/" : "/ultimas/p/".concat(pg, "/");
                        } else if (rootPage === "podcast") {
                            routeValue = pg === 1 ? "/podcast/ultimos/" : "/podcast/ultimos/p/".concat(pg, "/");
                        } else {
                            routeValue = pg === 1 ? "/".concat(rootPage, "/") : "/".concat(rootPage, "/p/").concat(pg, "/");
                        }
                        (0,gtm/* PageViewGTM */.sb)(window.location.pathname);
                        (0,fbConvetionAPI/* sendPageViewEventToFacebookAPI */.b)({
                            eventSourceUrl: window.location.href,
                            eventId: crypto.randomUUID()
                        });
                        setAtualPage(pg);
                        if (!noPagination) window.history.pushState("", "", routeValue);
                    }
                }
            });
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    });
    var totalPosts = allPosts.length;
    var hasMoreLocalPosts = visibleCount < totalPosts;
    var reachedEnd = isLastPage && !hasMoreLocalPosts;
    var shouldRenderLoadMoreButton = !noScroll && !reachedEnd;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "NewsContainer",
                children: [
                    dataPosts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListNews, {
                        items: dataPosts,
                        page: pageRef.current,
                        backgroundColor: backgroundColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mimir_LoadingLogo, {
                        isLoading: isLoading
                    }),
                    shouldRenderLoadMoreButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: handleLoadMore,
                            disabled: isLoading || isLastPage && !hasMoreLocalPosts,
                            className: "chip-hover-color [&.chip-hover-color]:hover:[&_path]:fill-mglGray50' rounded-full border-[0.5px] bg-mglGray50 px-6 py-3 font-semibold text-mglGray900 transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60 hover:[&.chip-hover-color]:bg-mglGray900 hover:[&.chip-hover-color]:text-mglGray50",
                            children: isLoading ? "carregando..." : "ver mais not\xedcias"
                        })
                    })
                ]
            }),
            pageNewsSpan && pageNewsSpan.finish()
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Layout/RecentNewsButton/index.tsx



function RecentNewsButton(param) {
    var link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/".concat(link, "/"),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "left-0 right-0 z-[997] mx-auto my-2 flex flex-row items-center rounded-2xl bg-mglBlue400 px-4 py-2 text-center leading-none text-mglGray50 no-underline",
            title: "Ver not\xedcias mais recentes",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        icon: "mdi:refresh",
                        width: 16,
                        height: 16
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ml-2",
                    children: "Ver not\xedcias mais recentes"
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/Layout/Title/index.tsx
var Title = __webpack_require__(9879);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/lib/sponsors.ts
var sponsors = __webpack_require__(6874);
// EXTERNAL MODULE: ./src/components/Layout/SponsoredCategoryHeader/index.tsx
var SponsoredCategoryHeader = __webpack_require__(2155);
;// CONCATENATED MODULE: ./src/components/Home/FeaturedLastNews/index.tsx
/* eslint-disable react/no-array-index-key */ /* eslint-disable react/no-unused-prop-types */ /* eslint-disable camelcase */ // @refresh reset












function FeaturedLastNews(param) {
    var _featuredLastNewsData = param.featuredLastNewsData, featuredLastNewsData = _featuredLastNewsData === void 0 ? null : _featuredLastNewsData, rootPage = param.rootPage, textTitle = param.textTitle, initialPage = param.initialPage, route = param.route, routeType = param.routeType, _recentButton = param.recentButton, recentButton = _recentButton === void 0 ? false : _recentButton, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag, _noPagination = param.noPagination, noPagination = _noPagination === void 0 ? false : _noPagination, _sponsoredCategory = param.sponsoredCategory, sponsoredCategory = _sponsoredCategory === void 0 ? undefined : _sponsoredCategory, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "bg-mglGray50" : _backgroundColor, _useLoadMoreButton = param.useLoadMoreButton, useLoadMoreButton = _useLoadMoreButton === void 0 ? false : _useLoadMoreButton, _hideAds = param.hideAds, hideAds = _hideAds === void 0 ? false : _hideAds;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var featuredLastNewsSpan = currentSpan && currentSpan.startChild({
        op: "featuredLastNews"
    });
    var ref1 = (0,react.useState)(false), noItemsFound = ref1[0], setNoItemsFound = ref1[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setNoItemsFound(false);
    }, [
        router
    ]);
    var PageNewsComponent = useLoadMoreButton ? PageNewsWithMimirAndButtom : PageNewsWithMimir;
    return !noItemsFound && /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContentLastNews, {
        backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
                backgroundColor: backgroundColor,
                isOnHeader: true,
                children: [
                    sponsors/* enableSponsoredCategories.includes */.P2.includes(sponsoredCategory) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsoredCategoryHeader/* SponseredCategoryHeader */.i, {
                        sponsoredCategory: sponsoredCategory
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        texto: textTitle,
                        color: "black",
                        headingTag: headingTag
                    })
                ]
            }),
            recentButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentNewsButton, {
                link: rootPage.toString()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNewsComponent, {
                posts: (featuredLastNewsData === null || featuredLastNewsData === void 0 ? void 0 : featuredLastNewsData.itens) || [],
                paginacao: (featuredLastNewsData === null || featuredLastNewsData === void 0 ? void 0 : featuredLastNewsData.paginacao) || "",
                rootPage: rootPage,
                initialPage: initialPage,
                route: route,
                routeType: routeType,
                noPagination: noPagination,
                setNoItemsFound: setNoItemsFound,
                backgroundColor: backgroundColor,
                hideAds: hideAds
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: featuredLastNewsSpan && featuredLastNewsSpan.finish()
            })
        ]
    });
}


/***/ }),

/***/ 2155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ SponseredCategoryHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_sponsors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6874);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



var SponseredCategoryHeader = function(param) {
    var sponsoredCategory = param.sponsoredCategory, _logoSize = param.logoSize, logoSize = _logoSize === void 0 ? undefined : _logoSize;
    var sponsorData = _lib_sponsors__WEBPACK_IMPORTED_MODULE_1__/* .sponsorCategoryData */ .Bw[sponsoredCategory];
    if (!sponsorData) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-4 flex flex-col items-end justify-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mb-1 text-[10px] font-light text-mglGray500",
                children: "Conte\xfado apoiado por"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-row gap-2",
                children: sponsorData.map(function(sponsor, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-row items-center"),
                        href: sponsor.url,
                        rel: "sponsored",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            title: sponsor.title,
                            src: sponsor.image.desktop.src,
                            height: sponsor.image.desktop.height,
                            width: sponsor.image.desktop.width,
                            alt: sponsor.title
                        })
                    }, "".concat(index));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                className: "mt-4 w-full border-t border-mglGray100 border-opacity-20"
            })
        ]
    });
};


/***/ }),

/***/ 9084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sb": function() { return /* binding */ PageViewGTM; },
/* harmony export */   "wL": function() { return /* binding */ SendEventGTMWithSingleString; }
/* harmony export */ });
/* unused harmony export SendEventGTM */
/* eslint-disable import/prefer-default-export */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable no-unused-expressions */ var PageViewGTM = function(url) {
    var pageEvent = {
        event: "pageview",
        page: url
    };
    window && window.dataLayer && window.dataLayer.push(pageEvent);
    return pageEvent;
};
var SendEventGTM = function(action, category, label, value) {
    var pageEvent = {
        category: category,
        action: action,
        label: label,
        value: value
    };
    window && window.dataLayer && window.dataLayer.push({
        event: "event",
        pageEvent: pageEvent
    });
    return pageEvent;
};
var SendEventGTMWithSingleString = function(value) {
    window && window.dataLayer && window.dataLayer.push({
        event: value
    });
};


/***/ }),

/***/ 8469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ny": function() { return /* binding */ mimir; },
/* harmony export */   "hi": function() { return /* binding */ api; }
/* harmony export */ });
/* unused harmony exports retryDelayWithJitter, site, validatesResponse, guia, directus */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios_retry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8662);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(3454);





var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_2___default()().publicRuntimeConfig;
// Em ambientes onde o ingress-nginx-controller exige PROXY protocol (LBaaS MGC),
// o tráfego intra-cluster Pod→ExternalIP morre com ECONNRESET. Em SSR usamos a
// URL interna do cluster (process.env, server-only). No browser, mantemos o
// host público. Em produção (sem INTERNAL_API_* definida no deployment),
// o fallback mantém o host público — comportamento inalterado.
var isServer = "object" === "undefined";
var apiBaseSSR = process.env.INTERNAL_API_BASE || publicRuntimeConfig.NEXT_PUBLIC_API_BASE;
var mimirBaseSSR = process.env.INTERNAL_API_MIMIR || publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR;
var guiaBaseSSR = process.env.INTERNAL_API_GUIA || publicRuntimeConfig.NEXT_PUBLIC_API_GUIA;
var api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(isServer ? apiBaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_BASE, "/api"),
    timeout: 10000,
    responseType: "json"
});
var site = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(isServer ? apiBaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_BASE, "/").concat(publicRuntimeConfig.NEXT_PUBLIC_API_VERSION),
    timeout: 10000,
    responseType: "json"
});
var mimir = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: isServer ? mimirBaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR,
    timeout: 10000,
    responseType: "json"
});
var guia = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: isServer ? guiaBaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_GUIA,
    timeout: 10000,
    responseType: "json"
});
// Directus é M2M/SSR-only (ver directusMateria.ts, chamado só de getServerSideProps).
// Base e token vêm de process.env (server-only) — NÃO de publicRuntimeConfig, que
// é serializado no bundle e vazaria o token no browser. No client, baseURL fica
// undefined e o guard `if (!directus.defaults.baseURL) return null` curto-circuita.
var directus = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: process.env.DIRECTUS_BASE,
    timeout: 10000,
    responseType: "json"
});
api.interceptors.request.use(function(config) {
    config.url = encodeURI(config.url);
    return config;
});
site.interceptors.request.use(function(config) {
    config.url = encodeURI(config.url);
    return config;
});
directus.interceptors.request.use(function(config) {
    config.url = encodeURI(config.url);
    config.params = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, config.params), {
        access_token: process.env.DIRECTUS_TOKEN
    });
    return config;
});
// 408 Request Timeout,
// 500 Internal Server Error,
// 502 Bad Gateway,
// 503 Service Unavailable ,
// 504 Gateway Timeout
// Se ECONNABORTED, vem do timeOut do Axios
// Se isNetworkOrIdempotentRequestError validado pelo axiosRetry
// Backoff exponencial puro (2^n * 100ms) acrescido de ±50% de jitter random.
// Diferente do `axiosRetry.exponentialDelay` (que adiciona apenas 0-20% pra
// cima), este expande o range pros dois lados — dispersa mais agressivamente
// rajadas simultâneas. Sob 100+ requests SSR concorrentes retentando ao mesmo
// tempo, o backend recebe um "thundering herd" exato a cada 200/400/800ms,
// e o colapso cascateia. ±50% transforma o spike em uma curva suave.
var RETRY_BASE_DELAY_MS = 100;
var RETRY_JITTER_RATIO = 0.5;
function retryDelayWithJitter(retryCount) {
    var base = Math.pow(2, retryCount) * RETRY_BASE_DELAY_MS;
    var jitter = base * RETRY_JITTER_RATIO * (Math.random() - 0.5) * 2;
    return Math.max(0, base + jitter);
}
var retryableHttpStatus = function(status) {
    return status === 408 || status === 500 || status === 502 || status === 503 || status === 504;
};
var shouldRetry = function(error) {
    var ref;
    return retryableHttpStatus((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) || error.code === "ECONNABORTED" || axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isNetworkOrIdempotentRequestError */ .ZP.isNetworkOrIdempotentRequestError(error);
};
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: retryDelayWithJitter,
    retryCondition: shouldRetry
});
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(site, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: retryDelayWithJitter,
    retryCondition: shouldRetry
});
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(directus, {
    retries: 3,
    shouldResetTimeout: true,
    retryDelay: retryDelayWithJitter,
    retryCondition: shouldRetry
});
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(mimir, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: retryDelayWithJitter,
    retryCondition: shouldRetry
});
var validatesResponse = function(dataResponseAPI) {
    var isCatch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, isCategory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, category = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", host = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, prevHost = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, pathName = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    var ref, ref1, ref2, ref3;
    // Usando o CT status que são:
    // case 0: //sucesso(200)
    // case 1: //erro no servidor(500)
    // case 2: //acesso negado(403)
    // case 3: //não encontrado(404)
    // case 4: //inconsistencia(400)
    // case 5: //metodo não permitido(405)
    // case 6: //redirect(301)
    // case 7: //redirect(301)
    var data = null;
    var statusCode = 0;
    if (!isCatch && dataResponseAPI) {
        data = dataResponseAPI.data;
        statusCode = dataResponseAPI.status;
        if ((data === null || data === void 0 ? void 0 : data.status) == null) {
            return {
                data: data,
                statusCode: statusCode
            };
        }
    }
    switch(isCatch ? (ref = dataResponseAPI.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.status : dataResponseAPI.data.status){
        case 3:
            if (!isCategory) {
                data = {
                    notFound: true,
                    props: {}
                };
            } else {
                data = {
                    redirect: {
                        statusCode: 301,
                        destination: "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL, "/").concat(category, "/")
                    },
                    props: {}
                };
            }
            break;
        case 8:
            return {
                data: {
                    headers: isCatch ? dataResponseAPI.response.data.headers : data.headers
                },
                statusCode: isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo
            };
            break;
        case 1:
        case 2:
        case 4:
        case 5:
            statusCode = isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo;
            break;
        case 6:
        case 7:
            data = {
                redirect: {
                    statusCode: isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo,
                    destination: isCatch ? dataResponseAPI.response.data.data.url : data.data.url
                },
                props: {}
            };
            break;
        default:
            if (isCatch) throw dataResponseAPI;
            statusCode = dataResponseAPI.status;
    }
    var localHost = publicRuntimeConfig.NEXT_PUBLIC_HOST;
    var desiredHost = (dataResponseAPI === null || dataResponseAPI === void 0 ? void 0 : (ref2 = dataResponseAPI.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.dominio) || localHost;
    // Não redireciona se já estamos servindo o host canônico deste deploy.
    // No preview (host = directus.hml.staging-canaltech.com.br) a API consumida é a do
    // staging, que declara `dominio = staging-canaltech.com.br`; sem este guard toda página
    // de conteúdo era expulsa pro staging. Prod/staging seguem canonicalizando hosts estrangeiros.
    if ((host === null || host === void 0 ? void 0 : host.toString()) !== (desiredHost === null || desiredHost === void 0 ? void 0 : desiredHost.toString()) && (host === null || host === void 0 ? void 0 : host.toString()) !== (localHost === null || localHost === void 0 ? void 0 : localHost.toString())) {
        var ref4, ref5;
        data = {
            redirect: {
                statusCode: 301,
                destination: "https://".concat(desiredHost).concat((dataResponseAPI === null || dataResponseAPI === void 0 ? void 0 : (ref4 = dataResponseAPI.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.url) || pathName || "")
            },
            props: {}
        };
    }
    // Erros de servidor/acesso (status 1/2/4/5) no caminho isCatch só setam statusCode e deixam
    // `data` nulo. Garante shape válido para os callers não estourarem em data.redirect. (FAWKES-37R)
    if (!data) {
        data = {
            notFound: true,
            props: {}
        };
    }
    return {
        data: data,
        statusCode: statusCode
    };
};



/***/ })

}]);